import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../../components/button/CustomButton';
import { secondaryBlue, secondaryYellow } from '../../../../utils/color';
import CustomModal from '../../../../components/modal/CustomModal';
import { ReactComponent as WarningIcon } from '../../../../assets/icons/warning.svg';
import { ReactComponent as PencilIcon } from '../../../../assets/icons/pencil.svg';

type ModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  handleSubmitCreate: () => void;
  setIsOpen: (value: boolean) => void;
  isAnnex: boolean;
};

const ContractUpdateModal = ({
  isLoading,
  isOpen,
  setIsOpen,
  handleSubmitCreate,
  isAnnex,
}: ModalProps) => {
  const { t } = useTranslation();
  return (
    <CustomModal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <Stack direction="column">
        <Stack direction="row" alignItems="center" mb={3}>
          {isAnnex ? (
            <Stack
              width={40}
              height={40}
              mr={2}
              bgcolor="secondaryBlue.100"
              borderRadius={1}
              justifyContent="center"
              alignItems="center"
            >
              <PencilIcon width="20px" fill={secondaryBlue[700]} />
            </Stack>
          ) : (
            <Stack
              width={40}
              height={40}
              mr={2}
              bgcolor="secondaryYellow.100"
              borderRadius={1}
              justifyContent="center"
              alignItems="center"
            >
              <WarningIcon width="20px" fill={secondaryYellow[700]} />
            </Stack>
          )}
          <Typography variant="heading4" color="primaryDark.600">
            {isAnnex
              ? t('contracts.updateModal.annex.title')
              : t('contracts.updateModal.changeRequested.title')}
          </Typography>
        </Stack>
        <Stack
          py={2}
          sx={{
            borderTop: `1px solid ${secondaryBlue[100]}`,
            borderBottom: `1px solid ${secondaryBlue[100]}`,
          }}
        >
          <Typography color="primaryDark.500" variant="body2">
            {isAnnex
              ? t('contracts.updateModal.annex.text')
              : t('contracts.updateModal.changeRequested.text')}
          </Typography>
        </Stack>
        <Stack mt={3} direction="row" gap={3} justifyContent="flex-end">
          <CustomButton onClick={handleSubmitCreate} loading={isLoading} variant="primary">
            {t('common.continue')}
          </CustomButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default ContractUpdateModal;
